import React from "react"
import { Label, Input } from "reactstrap"

const LabelInput = ({
  name,
  value,
  onChange,
  label,
  invalid = false,
  disabled = false,
  type = "text",
  size = "sm",
  className = "",
  placeholder = "",
  feedback = "",
}) => {
  return (
    <div>
      <Label className={className}>{label}</Label>
      <Input
        type={type}
        className="font-size-13"
        name={name}
        value={value}
        bsSize={size}
        onChange={onChange}
        invalid={invalid}
        placeholder={placeholder}
        disabled={disabled}
      />
      {feedback && <div className="text-danger small">{feedback}</div>}
    </div>
  )
}

export default LabelInput
